<template>

    <v-dialog persistent v-model="enablePopup" width="100%">

        <v-card>
            <v-card-title class="d-block">
                <div class="popup-title">
                    <slot name="title"></slot>
                </div>

                <v-icon v-if="success" size="90" class="d-block" color="success">
                    mdi-check-circle-outline
                </v-icon>
                <v-icon v-else size="90" class="d-block" color="error">
                    mdi-close-circle-outline
                </v-icon>

            </v-card-title>

            <v-card-text>
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>


    export default {
        name: 'GenericPopupResponseStatus',
        data(){
            return {
                enablePopup: false

            }
        },
        props: {
            showPopup: Boolean,
            success: Boolean,
        },
        watch:{
            showPopup(val){
                if(val){
                    this.enablePopup = true
                    const self = this
                    setTimeout(()=>{
                        self.$emit("hidePopup")
                    },3000)
                }else{
                    this.enablePopup = false
                }
            }
        }

    }
</script>


<style scoped lang="scss">

    .container_logo {
        padding: 15px;

        .logo {
            margin: 0 auto;
        }
    }

</style>